
import utils from '@/utils';
import api from '@/api/password';
import { defineComponent } from 'vue';
import { IElForm } from '@/types/element';
import { IUser } from '@/types/models';

interface IForm {
  password: string,
  confirmPassword: string,
}

interface IState {
  user: IUser;
  form: IForm;
}

export default defineComponent({
  data() {
    return {
      user: {} as IUser,
      form: {
        password: '',
        confirmPassword: '',
      },
    } as IState;
  },
  methods: {
    apiGet() {
      api.get((res) => {
        this.user = res.user;
      });
    },

    apiSubmit() {
      api.submit({
        password: this.form.password,
      }, (res) => {
        if (!res.value) return;
        utils.success('密码更改成功！');
      });
    },

    validatePass(rule: string, value: string, callback: (error?: Error) => void) {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.form.password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    },

    btnSubmitClick() {
      (this.$refs.form as IElForm).validate((valid) => {
        if (valid) {
          this.apiSubmit();
        }
      });
    },
  },
  mounted() {
    this.apiGet();
  },
});
